import React, { useEffect, useState } from "react";
import { Bell, BellSlash } from "@phosphor-icons/react";
import { toast } from "sonner";
import { pushSupported, currentSubscription, enablePush, disablePush } from "../lib/push";

export function PushToggle() {
  const [state, setState] = useState("loading"); // loading | off | on | unsupported | denied
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!pushSupported()) { setState("unsupported"); return; }
    if (Notification.permission === "denied") { setState("denied"); return; }
    currentSubscription().then((s) => setState(s ? "on" : "off")).catch(() => setState("off"));
  }, []);
  if (state === "loading" || state === "unsupported") return null;
  const toggle = async () => {
    setBusy(true);
    try {
      if (state === "on") { await disablePush(); setState("off"); toast.success("Notificaciones desactivadas en este dispositivo."); }
      else { await enablePush(); setState("on"); toast.success("Notificaciones activadas: te avisaremos al asignarte una reparación."); }
    } catch (e) {
      if (Notification.permission === "denied") setState("denied");
      toast.error(e?.message || "No se pudieron activar las notificaciones.");
    } finally { setBusy(false); }
  };
  if (state === "denied") {
    return (
      <div className="mt-1 px-3 py-2 text-[11px] text-slate-500 flex items-start gap-2" data-testid="push-denied" title="Permite las notificaciones para este sitio en la configuración del navegador">
        <BellSlash size={16} className="shrink-0 mt-0.5" /> Notificaciones bloqueadas por el navegador
      </div>
    );
  }
  const on = state === "on";
  return (
    <button onClick={toggle} disabled={busy} data-testid="push-toggle-btn" data-state={state}
      className={`mt-1 w-full flex items-center gap-2 px-3 py-2 text-sm rounded-sm transition-all hover:bg-slate-800 ${on ? "text-emerald-400 hover:text-emerald-300" : "text-orange-300 hover:text-white"}`}>
      {on ? <Bell size={16} weight="fill" /> : <Bell size={16} />}
      <span className="flex-1 text-left">{busy ? "Un momento…" : on ? "Notificaciones activas" : "Activar notificaciones"}</span>
      {!on && <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />}
    </button>
  );
}
